import { render, staticRenderFns } from "./pieEchart.vue?vue&type=template&id=a2630e36&scoped=true&"
import script from "./pieEchart.vue?vue&type=script&lang=js&"
export * from "./pieEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2630e36",
  null
  
)

export default component.exports